import { cn } from "@tellescope/design-system";
import { Flag } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface FlaggedNoteBannerProps {
  note: string;
  className?: string;
}

export const FlaggedNoteBanner = ({ note, className }: FlaggedNoteBannerProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div className={cn("rounded-sm border border-yellow-500 bg-yellow-500/10 px-4 py-3", className)}>
      <span className="flex items-center justify-between gap-2 text-sm font-medium text-yellow-700 dark:text-yellow-500">
        {t("Flagged note")}
        <Flag className="size-4 fill-current" />
      </span>
      <p className="mt-1 whitespace-pre-wrap text-sm font-light">{note}</p>
    </div>
  );
};
